import type { AppliedMove } from "@chessla/shared";
import { useEffect, useRef } from "react";
import { playChessMoveSound } from "@/shared/utils/chess-sound";

export const useTemporaryMoveSound = (moves: readonly AppliedMove[], enabled = true): void => {
  const played = useRef(0);
  useEffect(() => {
    if (enabled) for (const move of moves.slice(played.current)) playChessMoveSound(move.san);
    played.current = moves.length;
  }, [moves, enabled]);
};
